const COOKIE_CONSENT_STORAGE_KEY = 'ai-brokerage-cookie-consent-v1';
const COOKIE_CONSENT_EVENT = 'cookie-consent-updated';
const COOKIE_CONSENT_OPEN_EVENT = 'cookie-consent-open';

const defaultPreferences = {
  necessary: true,
  analytics: true,
  functional: true,
  marketing: true,
};

export function getDefaultCookiePreferences() {
  return { ...defaultPreferences };
}

export function getCookieConsent() {
  try {
    const raw = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    return {
      ...defaultPreferences,
      ...parsed,
      necessary: true,
    };
  } catch (error) {
    console.warn('[CookieConsent] Failed to parse consent record:', error);
    return null;
  }
}

export function hasCookieConsentChoice() {
  return !!getCookieConsent();
}

export function canUseAnalyticsCookies() {
  const consent = getCookieConsent();
  return !!consent?.analytics;
}

export function canUseFunctionalCookies() {
  const consent = getCookieConsent();
  // Default to allowing functional storage until the user makes a choice.
  return consent ? !!consent.functional : true;
}

export function saveCookieConsent(preferences) {
  const normalized = {
    ...defaultPreferences,
    ...preferences,
    necessary: true,
    version: 1,
    consentedAt: new Date().toISOString(),
  };

  window.localStorage.setItem(
    COOKIE_CONSENT_STORAGE_KEY,
    JSON.stringify(normalized)
  );

  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_EVENT, { detail: normalized }));

  return normalized;
}

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent(COOKIE_CONSENT_OPEN_EVENT));
}

export {
  COOKIE_CONSENT_STORAGE_KEY,
  COOKIE_CONSENT_EVENT,
  COOKIE_CONSENT_OPEN_EVENT,
};
